import Props from "./props";
import React from "react";
import Styled from "./styled";

const Nav: React.FC<Props> = ({ children, primary }) => {
    return <Styled primary={primary}>{children}</Styled>;
};

export default Nav;
